module.exports = __webpack_public_path__ + "img/video-block.266e353f.png";